
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { createSnapshot, getLanguages, getSnapshots, Language, Snapshot } from '@/core/services/snapshot-service'
import { useRouter } from 'vue-router'

export default defineComponent({
  setup() {
    const state = reactive({
      selectedLanguage: null as null | Language,
      languages: [] as Language[],
      requestId: '',
      snapshots: [] as Snapshot[]
    })

    const router = useRouter()
    async function createNewSnapshot() {
      if(state.selectedLanguage && state.requestId) {
        const newSnapshot = await createSnapshot(state.requestId, state.selectedLanguage.id)
        router.push({ name: 'SnapshotDetails', params: { id: newSnapshot.id } })
      }
    }

    onMounted(async () => {
      state.languages = await getLanguages()
      state.snapshots = await getSnapshots()
    })

    return {
      ...toRefs(state),
      createNewSnapshot
    }
  }
})
